// Singleton pattern canvases for node overlay rendering

let _linePatternCanvas: HTMLCanvasElement | null = null;
let _squaredPatternCanvas: HTMLCanvasElement | null = null;

export function getLinePatternCanvas(): HTMLCanvasElement {
  if (_linePatternCanvas) return _linePatternCanvas;
  const patternWidth = 30;
  const patternHeight = 20;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;
  canvas.width = patternWidth;
  canvas.height = patternHeight;
  ctx.lineWidth = 9;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'bevel';
  ctx.strokeStyle = 'rgba(0, 0, 0, .1)';
  ctx.moveTo(-patternWidth, patternHeight);
  ctx.lineTo(patternWidth, -patternHeight);
  ctx.moveTo(0, patternHeight);
  ctx.lineTo(patternWidth, 0);
  ctx.moveTo(0, patternHeight * 2);
  ctx.lineTo(patternWidth * 2, 0);
  ctx.stroke();
  _linePatternCanvas = canvas;
  return canvas;
}

export function getSquaredPatternCanvas(): HTMLCanvasElement {
  if (_squaredPatternCanvas) return _squaredPatternCanvas;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;
  canvas.width = 20;
  canvas.height = 20;
  ctx.fillStyle = '#2750E2';
  ctx.globalAlpha = .2;
  ctx.fillRect(0, 0, 10, 10);
  ctx.fillRect(10, 10, 10, 10);
  _squaredPatternCanvas = canvas;
  return canvas;
}
